// @ts-strict-ignore
/**
 * Created by claudenbach on 3/1/2017.
 */

import { LMEditorService } from './lm-editor.service';
import { LMFieldUtilService } from '@services/utils/lm-field-util.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

import { AppConstants } from '@utils/app.constants';
import { ListResource } from '@resources/list.resource';
import { LMContextService } from '@services/lm-context.service';

export const lmStateFieldSource = (
  lmEditorService: LMEditorService,
  lmFieldUtilService: LMFieldUtilService,
  lmFormatUtilService: LMFormatUtilService,
  lmContextService: LMContextService,
  response: any,
  searchTerm: any,
  sourceArguments: any
) => {

  const columnDef = sourceArguments.column as ListGridColumn;
  const listGridComponent = sourceArguments.grid.settings.userObject();
  const userFolderId = listGridComponent.listSpec?.userFolder;
  const fieldId = columnDef.displayField.fieldId;
  let dataView = sourceArguments.rowData as LMDataView;
  let onFilterRow = false;
  let filterCriteria: LMFilterFieldCriteria = null;
  let blankValue = '0';

  const isLimitedStates = columnDef?.displayField?.limitedStates?.length > 0;

  if (!dataView.hasOwnProperty('resourceId')) {
    // coming in as a dropdown on a filter, so no row data with the data view

    // currently, when you pass in the dataViewSet.header, no states will be returned.
    // So if we are in a list where some records exist, grab the first one to pass in
    // so we get actual states.
    onFilterRow = true;
    const dataViewSet: LMDataViewSet = listGridComponent.dataViewSet;
    if (dataViewSet.data.length > 0) {
      dataView = dataViewSet.data[0];
    } else {
      dataView = dataViewSet.header;
    }
  }

  // Limited states array may not contain the value for the field. Make sure to add it if it doesn't
  if (isLimitedStates) {
    const states = lmFormatUtilService.fieldStatesToOptionsArray(columnDef.displayField.limitedStates, true);
    if (onFilterRow) {
      if (states[0].label === '') {
        states[0].label = Soho.Locale.translate('ListStaticFieldFilterNotEntered');
        states[0].value = 'Not Entered';
      }
    } else {
      // not filter row, but has limited states. Check if a value is set, and if it's not in the limited states, add it
      const dvField = dataView.fields[columnDef.displayField.fieldId];
      if (states[0].label === '') {
        states[0].label = '&nbsp;';
      }
      if (!lmFieldUtilService.isBlank(columnDef.displayField.type, dvField.value)) {
        if (!states.some((state: LMStateValue) => state.value === dvField.value) ) {
          const state: LMStateValue = dvField.stateValues.filter((state: LMStateValue) => state.value === dvField.value)[0];
          states.unshift(state);
        }
      }
    }

    response(states);
    return;
  }

  if (!onFilterRow && !!columnDef.displayField?.type) {
    if ((columnDef.displayField.type as string).toLowerCase().includes('alpha') ) {
      blankValue = '';
    }
  }

  const listResource = new ListResource({
    resourceId: dataView.resourceId,
    listName: lmEditorService.listSpec.busListSpec.name
  });

  const selectListInfo = columnDef.displayField?.selectListInfo;

  let selectListName = '';
  let selectLink = null;
  if (selectListInfo) {
    selectListName = selectListInfo.selectListName;
    if (selectListInfo.selectLink) {
      selectLink = selectListInfo.selectLink;
    }
  }

  if (lmContextService.userDefinedStatesPageSizeAndIndicator() && !!searchTerm) {
    // todo: ppatton add startsWith option once parsing is complete for a columnDef.displayField.useStartsWith
    const operator =
      columnDef.displayField.displayAsDropdown && columnDef.displayField.useStartsWithFilterOp ? 'startsWith' : 'contains';

    filterCriteria = {
      operator,
      fieldId: fieldId,
      value: searchTerm,
    };
  }

  lmFieldUtilService.getUserDefinedStates({
    resource: listResource,
    fieldId,
    dataView,
    selectListName,
    selectLink,
    userFolderId,
    filterCriteria,
    onFilterRow,
    callback: (status, result) => {
      if (status === AppConstants.STATUS_COMPLETED) {
        let states;

        if (lmContextService.userDefinedStatesPageSizeAndIndicator()) {
          if (result && result.hasOwnProperty('states') && Array.isArray(result.states)) {
            states = lmFormatUtilService.fieldStatesToOptionsArray(result.states, !onFilterRow, blankValue, true, onFilterRow, true);
          }
        } else {
          if (Array.isArray(result)) {
            states = lmFormatUtilService.fieldStatesToOptionsArray(result, !onFilterRow, blankValue, true, onFilterRow, true);
          }
        }

        if (onFilterRow && !searchTerm) {
          const item = {
            value: 'Not Entered',
            label: Soho.Locale.translate('ListStaticFieldFilterNotEntered')
          };

          states = [ item, ...states ];
        }


        //TODO Add back the refine search message when disabled options work correctly,
        // https://github.com/infor-design/enterprise/issues/7150
        //
        // If there are more results, add the message
        if (result.hasMore) {
          const searchToRefine: LMStateValue = {
            value: 'NANSearch',
            label: Soho.Locale.translate('RefineSearch'),
            disabled: true
          };

          states = [ ...states, searchToRefine ];
        }

        dataView.fields[ fieldId ].stateValues = states;
        // var selRow = self.getSelectedRows();
        //
        // if (selRow[0] > -1 && self.dataViewSet.data.length > 0)
        //   self.dataViewSet.data[selRow].fields[column.field].stateValues = states;
        //
        // // put the state values on the header as they are used later
        // self.dataViewSet.header.fields[column.field].stateValues = states;
        response(states);
      } else if (status === AppConstants.VIEW_EXCEPTION) {
        // todo: cheryl is this a noop?
      }
    }
  });
};
